import { defineMessages } from 'react-intl';

export const messages: {
	editPromptHover: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearPromptHover: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	editPromptHover: {
		id: 'fabric.editor.ai.screens.preview.header.edit.hover',
		defaultMessage: 'Edit',
		description: 'Label for the edit prompt button in the preview screen',
	},
	clearPromptHover: {
		id: 'fabric.editor.ai.screens.preview.header.clear.hover',
		defaultMessage: 'Clear',
		description: 'Label for the clear prompt button in the preview screen',
	},
});
